'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircle = function ContentAddCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
  );
};
ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
ContentAddCircle.displayName = 'ContentAddCircle';
ContentAddCircle.muiName = 'SvgIcon';

exports.default = ContentAddCircle;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/content/add-circle.js
// module id = 2809
// module chunks = 0